import React from 'react'
import GitHubCalendar from 'react-github-calendar'
import { Grid } from '@material-ui/core'
import './Github.css'

function Github() {
  return (
    <Grid
      className='github'
      style={{ justifyContent: 'center', paddingBottom: '10px' }}
    >
      {/* <h3 className='github__title'>
        Days I <strong className='title__code'>Code</strong>
      </h3> */}
      <div className='github__contribution'>
        <GitHubCalendar
          username='lonebots'
          blockSize={9}
          blockMargin={2}
          color='#515390'
          fontSize={10}
        />
      </div>
    </Grid>
  )
}

export default Github
